<template>
  <div v-if="object">
    <div class="row text-white" style="background: #44927b">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>Файл</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <b>{{parent + ': ' + parentId}}</b>
        <base-input label="Комментарий к файлу"
                    v-model="object.description"
                    :value="object.description"
        ></base-input>
      </div>
      <div class="col-md-8"></div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <form v-if="object.id === 0 || updateFile" id="uploadForm" enctype="multipart/form-data">
          <input type="file" id="file" accept=".xls,.docx" name="file">
        </form>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";
 import {userService} from "@/services/user.service";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null,
     parent: null,
     parentId: null,
     updateFile: false  //allows to update file instead existing
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed;
         if (this.object.id === 0 || this.updateFile) {
           let parent = this.item.parent ? this.item.parent : this.parent;
           let parentId = this.item.parentId ? this.item.parentId : this.parentId;
           let url = 'file/' + parent + '/' + parentId + '/' + this.object.description;
           let up = document.querySelector('#file');
           let formData = new FormData();
           formData.append("file", up.files[0]);
           renewed = await this.$repo.uploadFile(url, formData);
         } else {
           renewed = await this.$repo.save(this.object, 'file')
         }

         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     }
   },
   mounted() {
     this.object = this.item.object ? JSON.parse((JSON.stringify(this.item.object))) : {id: 0, description: ''};
   }
 }
</script>
